module.exports = __webpack_public_path__ + "img/C3.70c1fe60.png";